import { render } from "./IdentityVerificationSection.vue?vue&type=template&id=5c6161b0"
import script from "./IdentityVerificationSection.vue?vue&type=script&lang=js"
export * from "./IdentityVerificationSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__